import React, { useState, useEffect } from 'react'
import { api_url } from '../../Constants/web_services';
import { useSelector } from 'react-redux';
import { selectUserData, selectSignedIn } from '../../Redux/UserSlice';
import { Slider } from 'antd';
import { useParams } from 'react-router-dom';
import Pusher from 'pusher-js';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Button, Input, Space } from 'antd';

const Conversation = ({ company }) => {
    const isSignedIn = useSelector(selectSignedIn);
    const userData = useSelector(selectUserData);
    const [companyData] = useState(company);



    const { id } = useParams();

    const { ticketId } = useParams;
    const [ticket, setTicket] = useState('');
    const [chat, setChat] = useState([]);
    const [messageInput, setMessageInput] = useState('');
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(8);
    const [selectedImage, setSelectedImage] = useState(null);

    const [passwordVisible, setPasswordVisible] = React.useState(false);

    const generateTicket = (userId, companyId) => {
        const randomNumber = Math.floor(Math.random() * 1000);  // Random number for uniqueness
        const timestamp = Date.now();  // Timestamp for additional uniqueness
        return `${userId}_${companyId}_${randomNumber}_${timestamp}`;
    };

    useEffect(() => {
        const fetchOrderDetails = async () => {
            try {
                const token = localStorage.getItem('token'); // Retrieve the token from local storage
                const response = await fetch(`${api_url}/api/conversation`, {
                    headers: {
                        'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
                    },
                });
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                const orderDetailData = await response.json();
                setTicket(orderDetailData?.data);
            } catch (error) {
                console.error("Error fetching order details:", error);
            }
        };

        fetchOrderDetails();
    }, [userData?.id]);

    useEffect(() => {
        fetchMessages(0, limit);
    }, [userData?.id]);

    const fetchMessages = async (offset, limit) => {
        try {
            const token = localStorage.getItem('token'); // Retrieve the token from local storage
            const response = await fetch(`${api_url}/api/get-conversation-user/${companyData?.id}?offset=${offset}&limit=${limit}`, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
                },
            });
            if (!response.ok) {
                throw new Error("Failed to fetch messages");
            }
            const chatData = await response.json();
            setChat(prevChat => [...prevChat, ...chatData.messages]);
            setOffset(prevOffset => prevOffset + limit);
            setLimit(8);
        } catch (error) {
            console.error("Error fetching messages:", error);
        }
    };

    const loadMoreMessages = () => {
        fetchMessages(offset, limit);
    };

    useEffect(() => {
        if (ticketId) {
            Pusher.logToConsole = false;
            const pusher = new Pusher('71f5f5697ce5f5af59aa', {
                cluster: 'ap2',
                encrypted: true
            });

            const channel = pusher.subscribe(`chat.${ticketId}`);

            channel.bind("App\\Events\\MessageSent", function (data) {
                setChat(prevChat => [data.message, ...prevChat]);
                const chatBox = document.querySelector('.chat-box');
                if (chatBox) {
                    chatBox.scrollTop = chatBox.scrollHeight;
                }
            });

            return () => {
                channel.unbind_all();
                channel.unsubscribe();
            };
        }
    }, [ticketId]);

    const conversation = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append('message', messageInput);
            formData.append('ticket_id', ticketId);
            formData.append('user_id', userData?.id);
            formData.append('company_id', companyData?.id);
            formData.append('sender_id', userData?.id);
            formData.append('image', selectedImage); // Include selected image in the request

            const token = localStorage.getItem('token'); // Retrieve the token from local storage
            const response = await fetch(`${api_url}/api/conversation`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
                },
                body: formData,
            });

            if (!response.ok) {
                throw new Error("Failed to send message");
            }
            setMessageInput('');
            setSelectedImage(null); // Reset selected image after sending
        } catch (error) {
            console.error("Error sending message:", error.message);
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setSelectedImage(file);
    };

    return (
        <>
            {/*Request a Quote*/}
            <div className="container">
                <div
                    id="aon-provider-conversaion"
                    className="sf-provi-qoute-box cleafix m-b50 sf-provi-fullBox col-md-12 mb-4"
                >
                    <h3 className="sf-provi-title fw-800 text-drk-primary s-22">Conversaion</h3>
                    <div className="sf-divider-line" />
                    <div className="row col-md-12 justify-content-between ml-1 ">

                        <div className="card  aon-card border-0 shadow p-3" style={{ backgroundColor: '#26418C', }}>
                            <div className="card-header bg-transparent aon-card-header py-1">
                                <div className="row  justify-content-around pb-3">
                                    <div className="col-md-9">

                                        <h4 className="s-16 fw-700 text-warning text-capitalize">
                                            <i className="fa fas fa-users-between-lines m-2" />
                                            {""}Conversaion Ticket No.
                                        </h4>
                                    </div>
                                    <div className="col-md-3 ">

                                        <Space direction="horizontal">
                                            <Input.Password
                                                placeholder="input password"
                                                visibilityToggle={{
                                                    visible: passwordVisible,
                                                    onVisibleChange: setPasswordVisible,
                                                }}
                                            />
                                            <Button
                                                style={{
                                                    width: 80,
                                                }}
                                                onClick={() => setPasswordVisible((prevState) => !prevState)}
                                            >
                                                {passwordVisible ? 'Hide' : 'Show'}
                                            </Button>
                                        </Space>
                                    </div>
                                </div>
                                <div className="row  justify-content-center">
                                    <div className="col-12 col-md-6">
                                        <sup className="ml-5 fw-600 text-warning text-capitalize"><u>Agent from SE</u></sup>
                                    </div>
                                    <div className="col-6 col-md-6">
                                        {/* <h4 className="s-16 fw-700 text-022279 text-capitalize">
                                    <i className="fa fa-user m-2" />
                                    {userData?.username} Profile
                                </h4> */}
                                        <sup className="ml-4 fw-600 text-warning text-capitalize"><u>You can chat here</u></sup>
                                    </div>
                                </div>
                            </div>
                            <div className="chat-box">
                                <div className="row justify-content-center">

                                    {/* <button className="loadMore col-3 text-center border-0 fw-700" type="button" onClick={loadMoreMessages}>Load More</button> */}
                                </div>

                                {/* {[...chat].reverse().map((message, index, array) => (
                                <React.Fragment key={`message-container-${message.id}`}>
                                    {(index === 0 || array[index - 1].date !== message.date) && (
                                        <div className="row justify-content-between m-2" key={`message-timeline-${message.id}`}>
                                            <div className="col-5 p-0">
                                                <hr className='timeLine' />
                                            </div>
                                            <div className="col-2 p-0">
                                                <div className="message-date text-center fw-700">{moment(message.date).format('DD-MMM-YYYY')}</div>
                                            </div>
                                            <div className="col-5 p-0">
                                                <hr className='timeLine' />
                                            </div>
                                        </div>
                                    )}
                                    <div className={`message-container ${message.sender_id === message.company_id ? 'client' : 'you'}`}>
                                        <div className="message-content">
                                            {message?.image ? (
                                                <img src={api_url + '/' + message?.image} alt="no-img" className="img-fluid" style={{ maxWidth: '120px' }} />
                                            ) : (
                                                <span className={`ml-1 fw-700 ${message.sender_id === message.company_id ? '' : ''}`}>
                                                    {message.message}
                                                </span>
                                            )}
                                            <p className='p-0 row justify-content-end mr-1 mb-0 font-size-12'>
                                                
                                            </p>
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))} */}
                            </div>


                            <form onSubmit={conversation}>
                                <div className="input-container">
                                    <input
                                        type="text"
                                        id="message"
                                        placeholder="Type your message..."
                                        value={messageInput}
                                        onChange={(e) => setMessageInput(e.target.value)}
                                    />
                                    <div className="attachment-container">
                                        <label htmlFor="file-input">
                                            <i className="fa fa-paperclip attachment-icon" id="attachment-icon"></i>
                                        </label>
                                        <input type="file" id="file-input" name="image" className="file-input" onChange={handleImageChange} />
                                    </div>
                                    <button id="send-btn" type='submit' disabled={messageInput === " "}>Send</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Conversation